// extracted by mini-css-extract-plugin
module.exports = {"addBoardTile":"AddBoardTile_addBoardTile__j3v7-","clickable":"AddBoardTile_clickable__2K3Hs","menu":"AddBoardTile_menu__3nlGL"};